import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/brand/Logo";

export function Splash() {
  return (
    <div className="flex h-dvh items-center justify-center bg-ink-950" data-testid="app-splash">
      <LogoMark size={40} className="animate-pulse opacity-80" />
    </div>
  );
}

export function ProtectedRoute() {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Splash />;
  if (!session) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }
  return <Outlet />;
}

export function safeNext(raw) {
  return raw && raw.startsWith("/") && !raw.startsWith("//") ? raw : "/";
}

export function PublicOnlyRoute() {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Splash />;
  if (session) return <Navigate to={safeNext(new URLSearchParams(location.search).get("next"))} replace />;
  return <Outlet />;
}
